// extracted by mini-css-extract-plugin
export default {"table":"List_table__xdPmC","thead":"List_thead__-ouGI","row":"List_row__+cOi7","col":"List_col__73sv2"};